import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "videoSettings.title.label",
    defaultMessage: "Video background",
    description: "Title for video settings page",
  },
  alertInfo: {
    id: "videoSettings.alert.info.text",
    defaultMessage:
      "Below, you can preset whether the background in the meeting should have a blur filter applied or not. Please note that different devices may have different capabilities, so it may not always be possible to blur the background in advance.",
    description: "Alert info text",
  },
});
